import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store, createModelSelector } from '@ngxs/store';
import { map } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';
import { VxButtonComponent } from '@ui/button/button.component';
import { VxIconComponent } from '@ui/icon/icon.component';
import { VxSkeletonComponent } from '@ui/skeleton/skeleton.component';
import { OAuth2ConsentInfo } from 'src/app/models/oauth2';
import { Entity } from 'src/app/store/common/entity';
import {
  OAuth2ConfirmConsentChallengeAction,
  OAuth2GetConsentInfoAction,
} from 'src/app/store/oauth2/oauth2.actions';
import { OAuth2State } from 'src/app/store/oauth2/oauth2.state';
import { AuthHeaderComponent } from '../components/auth-header/auth-header.component';
import { AuthPanelComponent } from '../components/auth-panel/auth-panel.component';
import { AuthShellComponent } from '../components/auth-shell/auth-shell.component';

interface VM {
  currentConsent: Entity<OAuth2ConsentInfo>;
  isLoading: boolean;
}

@Component({
  selector: 'app-page-oauth2-consent',
  imports: [
    AsyncPipe,
    TranslocoModule,
    AuthHeaderComponent,
    AuthPanelComponent,
    AuthShellComponent,
    VxButtonComponent,
    VxIconComponent,
    VxSkeletonComponent,
  ],
  templateUrl: './consent.component.html',
})
export class OAuth2ConsentPageComponent implements OnInit {
  route = inject(ActivatedRoute);
  store = inject(Store);

  oAuth2ConsentChallenge?: string;

  vm$ = this.store
    .select(
      createModelSelector({
        currentConsent: OAuth2State.currentConsent,
        isLoading: OAuth2State.isAcceptingConsent,
      })
    )
    .pipe(
      map(state => {
        return {
          currentConsent: state.currentConsent,
          isLoading: state.isLoading,
        } as VM;
      })
    );

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      if (params['consent_challenge']) {
        this.oAuth2ConsentChallenge = params['consent_challenge'];
        this.store.dispatch(
          new OAuth2GetConsentInfoAction(this.oAuth2ConsentChallenge!)
        );
      }
    });
  }

  onConsent() {
    this.store.dispatch(
      new OAuth2ConfirmConsentChallengeAction(this.oAuth2ConsentChallenge!)
    );
  }
}
